import {
    Component,
    forwardRef,
    Input,
    Inject,
    Output,
    EventEmitter,
} from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { HomeController } from "@shared/src/controllers/home/home.controller";
import { UpdatePaymentDialogDialogComponent } from "./dialog/updatepaymentdialog.dialog.component";

export const SharedUpdatePaymentDialogComponent_NOSEPERQUESERVEIXA: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => UpdatePaymentDialogDialogComponent),
    multi: true,
};

@Component({
    selector: "updatepayment-dialog",
    templateUrl: "./shared.updatepaymentdialog.component.html",
    styleUrls: ["./shared.updatepaymentdialog.component.scss"],
    providers: [SharedUpdatePaymentDialogComponent_NOSEPERQUESERVEIXA],
})
export class SharedUpdatePaymentDialogComponent {
    @Output() public onConfirm: EventEmitter<boolean> =
        new EventEmitter<boolean>();
    @Output() public onCancel: EventEmitter<boolean> =
        new EventEmitter<boolean>();

    @Input() title: string = "";
    @Input() paramstitle: any;

    @Input() routePartCMRId: number;
    @Input() payment: string;
    @Input() amount: number;
    @Input() external: boolean;
    
    private _expanded: boolean = false;
    @Input() public set expanded(value: boolean) {
        if (value)
            this.clickHelpNoIonic();

        this._expanded = value;
    }

    public get expanded(): boolean {
        return this._expanded;
    }

    public useIonic: boolean = false;

    public position = "below";

    constructor(
        private translate: TranslateService,
        private mdDialog: MatDialog,
        @Inject("HomeController") protected homecontroller: HomeController
    ) {
        if (homecontroller.useIonic) this.useIonic = homecontroller.useIonic();
    }

    ngOnInit() { }

    clickHelpNoIonic() {
        let dialog = this.mdDialog.open(UpdatePaymentDialogDialogComponent, {
            disableClose: true,
            width: "600px",
            //height: '300px',
            data: { 
                title: this.gettitle(), 
                payment: this.payment, 
                amount: this.amount, 
                routePartCMRId: 
                this.routePartCMRId,
                external: this.external
            },
        });

        dialog.backdropClick().subscribe((data) => {
            this.onCancel.next(true);
        });

        dialog.componentInstance.onResolve.subscribe((data: boolean) => {
            if (data) this.onConfirm.next(true);
            else this.onCancel.next(true);
        });

        this.mdDialog.afterAllClosed.subscribe(() => { });
    }

    gettitle() {
        if (this.title != null && this.title != "")
            return this.translate.instant(
                this.title,
                this.paramstitle
            );

        return "";
    }
}
